import React, { Component } from "react";
import PropTypes from "prop-types";
import ScriptTag from "@components/ScriptTag";
import _get from "lodash/get";
import getConfig from "next/config";
import ContentEditorProductDescription from "@components/ProductPage/ProductDescription/ContentEditorProductDescription";
import StaticHTMLProductDescription from "@components/ProductPage/ProductDescription/StaticHTMLProductDescription";
import { isServer } from "@lib/helpers";

const {
  publicRuntimeConfig: { contentProviders },
} = getConfig();

class LoadBeeProductDescription extends Component {
  componentDidMount() {
    if (window && window.loadbeeIntegration) {
      window.loadbeeIntegration.loadbeeInitIframeResizer();
      window.loadbeeIntegration.checkAvailability(this.props.ean);
    }
  }

  render() {
    const { ean, staticHTML, contentEditorBlock, brand } = this.props;

    return (
      <>
        <div
          className="loadbeeTabContent"
          data-loadbee-apikey={_get(
            contentProviders,
            "providers.loadBee.apiKey",
            ""
          )}
          data-loadbee-gtin={ean}
          data-loadbee-locale="ro_RO"
        />

        {/*
          Fallback content is hidden by CSS wizardry
          The provided callback is unnatural to use in a React context
        */}
        <div className="loadBeeTabContentFallback">
          {contentEditorBlock.length !== 0 ? (
            <ContentEditorProductDescription
              contentEditorBlock={contentEditorBlock}
              staticHTML={staticHTML}
              ean={ean}
              brand={brand}
            />
          ) : (
            <StaticHTMLProductDescription
              staticHTML={staticHTML}
              ean={ean}
              brand={brand}
            />
          )}
        </div>

        <style>{`
          .loadBeeTabContentFallback {
            display: none
          }

          .loadbeeTabContent:empty + .loadBeeTabContentFallback {
            display:block
          }
        `}</style>

        {!isServer && !window.loadbeeIntegration && (
          <ScriptTag
            type="text/javascript"
            src={`https://cdn.loadbee.com/js/loadbee_integration.js`}
            async
          />
        )}
      </>
    );
  }
}

LoadBeeProductDescription.propTypes = {
  staticHTML: PropTypes.string.isRequired,
  contentEditorBlock: PropTypes.string.isRequired,
  ean: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
};

export default LoadBeeProductDescription;
